import { render } from "./PrivateUkPensionPage.vue?vue&type=template&id=1bb476e8"
import script from "./PrivateUkPensionPage.vue?vue&type=script&lang=js"
export * from "./PrivateUkPensionPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__